import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
} from 'react';
import { useSelector } from 'react-redux';
import Comment from '../Comment/Comment';
import styles from './Body.module.scss';

const findFirstElementInViewPort = (elements) =>
  Array.prototype.find.call(
    elements,
    (element) => element.getBoundingClientRect().y >= 0 // nav height offset
  );

const Body = ({
  request,
  comments,
  onEditBtnClick,
  onDeleteComment,
  editedCommentData = null,
  canChange,
}) => {
  const scrollDownRef = useRef();
  const commentsContainerRef = useRef();

  const currentUserId = useSelector(
    (state) => state.authentication.userInfo.WorkerId
  );

  const scrollToBottom = useCallback(() => {
    scrollDownRef.current.scrollIntoView({ behavior: 'auto' });
  }, [request.id]);

  useEffect(() => {
    if (comments) {
      scrollToBottom(0);
    }
  }, [comments]);

  const scrollTo = useMemo(() => {
    // Find all elements in container which will be checked if are in view or not
    const nodeElements = commentsContainerRef.current?.querySelectorAll(
      '[comment-data-item]'
    );
    if (nodeElements) {
      return findFirstElementInViewPort(nodeElements);
    }

    return undefined;
  }, [commentsContainerRef]);

  useLayoutEffect(() => {
    if (scrollTo) {
      // Scroll to element with should be in view after rendering
      scrollTo.scrollIntoView();
      // Scroll by height of nav
      window.scrollBy(0, 0);
    }
  }, [scrollTo]);

  return (
    <div
      className={styles.modalBody}
      ref={commentsContainerRef}
    >
      {comments?.length ? (
        comments.map((comment) => (
          <Comment
            key={comment.id}
            containerRef={commentsContainerRef}
            belongsToCurrentUser={
              currentUserId.toString() === comment.user?.id.toString()
            }
            commentData={comment}
            onEditBtnClick={onEditBtnClick}
            onDeleteComment={onDeleteComment}
            editedCommentData={editedCommentData}
            requestId={request.id}
            canChange={canChange}
          />
        ))
      ) : (
        <div>Комментариев пока нет</div>
      )}
      <div
        className={styles.scrollDown}
        ref={scrollDownRef}
      />
    </div>
  );
};

export default Body;
